import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Base } from "../../components/RootLayout";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Button } from "react-bootstrap";
import TopNavigation from "../../components/TopNavigation";

import * as PageRoutes from "../../utils/route_pages";
import * as Assets from "../../utils/svg_assets";
import { InformationDialog } from "../../components/DialogCollection";
import { UserDetailDM } from "../../data_model/user_detail_dm";
import ApiUtils from "../../utils/api_utils";

const AvatarEditor = (props) => {
  const { profile, updateUserProfile, file_upload, setRoot } = props;
  const cropperRef = useRef(null);
  const hiddenFileInput = useRef(null);
  const navigate = useNavigate();
  const [avatar, setAvatar] = useState({
    src: file_upload ?? profile.profile_pic_url,
    isEdit: false,
    croppedFile: null,
  });
  const [dialog, setDialog] = useState({
    show: false,
    message: "",
    is_success: false,
  });

  const [temp, setTemp] = useState({
    canvas: null,
    fileName: null,
    mimeType: null,
  });

  const [isLoading, setIsLoading] = useState(false);
  const reset = () => {
    setRoot({ file_upload: null });
    setAvatar({
      src: profile.profile_pic_url,
      isEdit: false,
      croppedFile: null,
    });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    const now = Date.now();

    setTemp({
      canvas: cropper.getCroppedCanvas(),
      fileName: `${profile.first_name}-${now}.png`,
      mimeType: "image/png",
    });

    setAvatar({
      ...avatar,
      isEdit: true,
    });
  };
  const urlToFile = async () => {
    const res = await fetch(temp.canvas.toDataURL());
    const buf = await res.arrayBuffer();
    return new File([buf], temp.fileName, { type: temp.mimeType });
  };

  const saveFile = async () => {
    setIsLoading(true);
    if (avatar.isEdit) {
      updateUserProfile({
        profile_pic: await urlToFile(),
      })
        .then(function (response) {
          var new_profile = UserDetailDM.fromJson(response.data);
          props.setProfile({ profile: new_profile });
          setIsLoading(false);
          setDialog({
            show: true,
            message: "Update Profile Success",
            is_success: true,
          });
        })
        .catch(function (error) {
          setIsLoading(false);
          setDialog({
            show: true,
            message: "Update Profile Failed",
            is_success: false,
          });
        });
    } else {
      setIsLoading(false);
    }
  };
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    getBase64(fileUploaded);
  };

  const handleDialogClose = () => {
    setDialog({
      ...dialog,
      show: false,
    });

    if (dialog.is_success) {
      navigate(PageRoutes.editProfile);
    }
  };

  const getBase64 = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // console.log(reader.result);
      setRoot({ file_upload: reader.result });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };
  return (
    <Base>
      <TopNavigation
        titlePage="Profile Image Editor"
        toPath={PageRoutes.editProfile}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <input
        type="file"
        accept="image/*"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: "none" }} // Make the file input element invisible
      />
      <Cropper
        src={ApiUtils.validateImgUrl({ url: avatar.src })}
        style={{ height: 300, width: "100%" }}
        initialAspectRatio={1}
        guides={true}
        crop={onCrop}
        ref={cropperRef}
      />
      <div
        style={{
          padding: "20px",
        }}
      >
        <Button variant="danger" className="w-100" onClick={handleClick}>
          Upload Image
        </Button>
        <div style={{ height: "10px" }} />
        {isLoading && (
          <Button variant="secondary" className="w-100">
            Loading ...
          </Button>
        )}
        {!isLoading && (
          <Button variant="secondary" className="w-100" onClick={saveFile}>
            Save Image
          </Button>
        )}
        <div style={{ height: "10px" }} />
        <Button variant="secondary" className="w-100" onClick={reset}>
          Reset Image
        </Button>
      </div>
      <InformationDialog
        message={dialog.message}
        closeLabel="OK"
        show={dialog.show}
        onHide={handleDialogClose}
      />
    </Base>
  );
};

const mapStateToProps = (state) => ({
  profile: state.ProfileSM.profile,
  file_upload: state.RootSM.file_upload,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserProfile: dispatch.ProfileSM.updateUserProfile,
  setProfile: dispatch.ProfileSM.setProfile,
  setRoot: dispatch.RootSM.setRoot,
});

export default connect(mapStateToProps, mapDispatchToProps)(AvatarEditor);
